let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");

let main = function () {
    var PurchaseLicenseView = Backbone.View.extend({
        el: "#purchaseModal",
        model: new Backbone.Model({
            status: "Create"
        }),
        events: {
            "click .purchase-row .device-quantity": "_deviceChoose",
            "click .purchase-row .paymode-choose": "_paymodeChoose",
            "click .edit-quantity img": "_editQuantity",
            "change .license-duration": "_editDuration",
            "click .pay-order": "_payOrder",
            "click .close-license": "hide"
        },
        initialize: function () {
            var self = this;
            self.resetModel();
            self.listenTo(self.model, "change", this.calculateLicensePrice);
            self.listenTo(self.model, "Paid", this.paidSuccess);
        },
        show: function(){
            this.resetView();
            this.$el.modal("show");
        },
        hide: function() {
            this.$el.modal("hide");
        },
        _payOrder: function (evt) {
            var self = this, jxhr, orderNo = Math.ceil(Math.random() * 100000), btn = $(evt.currentTarget),
                amount = self.model.get("amount"), channel = self.model.get("channel");
            console.log(self.model.toJSON());
            jxhr = $.post("/onlinePay/onlineCharge", self.model.toJSON());
            jxhr.done(function (response) {
                if (response.success) {
                    var charge = response.charge;
                    // self.model.set({
                    //     paid:charge.paid,
                    //     status:"Order",
                    //     id:charge.id,
                    //     orderNo:charge.orderNo,
                    //     transactionNo:charge.transactionNo
                    // });
                    if (self.model.get("channel") == "alipay_qr") {
                        $(".qrcode .pay-model-alipay").removeClass('hidden').siblings('img').addClass('hidden');
                    } else {
                        $(".qrcode .pay-model-wechat").removeClass('hidden').siblings('img').addClass('hidden');
                    }
                    if (response.image) {
                        console.log(response.image);
                        $('.qrcode').removeClass("hidden").find(".pay-code").attr("src", response.image);
                        btn.addClass('hidden');
                    }
                }
            });
        },
        _deviceChoose: function (evt) {
            var crt = $(evt.currentTarget);
            crt.addClass("checked").siblings(".device-quantity").removeClass("checked");
            if (crt.hasClass("basic")) {
                this.model.set("deviceQuantity", 2);
                this.$el.find(".edit-quantity span").text(2);
            }
        },
        _editDuration: function () {
            var duration = this.$(".license-duration").val();
            this.model.set("duration", parseInt(duration));
        },
        _editQuantity: function (evt) {
            var btn = $(evt.currentTarget);
            var deviceQuantity = this.model.get("deviceQuantity");
            if (btn.hasClass("plus")) {
                deviceQuantity++;
            } else {
                deviceQuantity--;
            }
            if (deviceQuantity <= 0) {
                deviceQuantity = 1;
            }
            this.$el.find(".edit-quantity span").text(deviceQuantity);
            this.model.set("deviceQuantity", deviceQuantity);
        },
        _paymodeChoose: function (evt) {
            var crt = $(evt.currentTarget), payModel = '';
            crt.addClass("checked").siblings(".paymode-choose").removeClass("checked");
            if(crt.data("channel")=="tooie"){
                window.open("http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDA5ODQ3N18yMTgyMDhfODAwMDk4NDc3XzJf");
                this.$el.find(".pay-order").addClass('hidden');
            }else{
                this.model.set("channel", crt.data("channel"));
                this.$el.find(".pay-order").removeClass('hidden');
            }
            console.log("choose payMode ---" + crt.data("channel"));
        },
        _reOrder:function(){
            var el = this.$el;
            el.find(".qrcode").addClass('hidden');
            el.find(".pay-order").removeClass('hidden');
        },
        paidSuccess:function(){
            this.$el.modal("show");
            this.$el.find(".order-page").addClass("hidden");
            this.$el.find(".paid-success").removeClass("hidden");
            this.trigger("needRefresh");
        },
        resetView:function(){
            var el = this.$el;
            el.find(".order-page").removeClass("hidden");
            el.find(".paid-success").addClass("hidden");
            el.find(".device-choose .basic").addClass("checked").siblings("div").removeClass("checked");
            el.find(".paymode .paymode-choose[data-channel='alipay_qr']").addClass("checked").siblings("div").removeClass("checked");
            el.find(".license-duration").val(1);
            el.find(".edit-quantity span").text(2);
            el.find(".qrcode").addClass('hidden');
            this.resetModel();
        },
        resetModel:function(){
            var self = this;
            self.model.set({
                deviceQuantity: 2,
                duration: 1,
                amount: self.calculateLicensePrice(),
                price: window.TOOIE_INIT_PARAMS.charges.price,
                channel: "alipay_qr",
                chargesId: self.$el.find(".purchase-license").data('id')
            });
        },
        calculateLicensePrice: function () {
            var duration = this.model.get("duration");
            var deviceQuantity = this.model.get("deviceQuantity");
            var price = this.model.get("price");
            var amount = 0;
            if (duration && deviceQuantity) {
                var cardinal = 1;
                if (deviceQuantity <= 2) {
                    cardinal = 1;
                } else {
                    cardinal = Math.ceil((deviceQuantity - 2) / 3) + 1;
                }
                amount = duration * cardinal * price;
            } else {
                amount = 100;
            }
            this.$el.find(".should-pay .text-span").text(amount);
            this.model.set("amount", amount, {silent: true});
            this._reOrder();
            console.log("license price is ---" + amount);
            return amount;
        },
        chargeSuccess: function () {

        }
    });
    return PurchaseLicenseView;
};

let exportedValue = main();
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/view/comp/PurchaseLicenseView.js